module.exports = __webpack_public_path__ + "img/logovigilado2024medium.8c22a5e6.png";